// extracted by mini-css-extract-plugin
export default {"dashboard":"SolutionCreator_dashboard__9ScZQ"};